import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { FaSortAmountDown } from 'react-icons/fa';
import { IoIosClose } from 'react-icons/io';
import { IoArrowBack } from 'react-icons/io5';
import { OrderDir, OrderOption, OrderType } from 'types/perMachineTypes';

interface Props {
  orderValue: OrderOption | undefined; // 현재 정렬 상태(없으면 undefined)
  orderChange: React.Dispatch<React.SetStateAction<OrderOption | undefined>>;
  orderDropdownOpen: boolean;
  setOrderDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function PerMachineSortDropdown({
  orderValue,
  orderChange,
  orderDropdownOpen,
  setOrderDropdownOpen,
}: Props) {
  const isActive = (type: OrderType, dir: OrderDir) =>
    orderValue?.type === type && orderValue?.dir === dir;

  const handleSelect = (ek: string | null) => {
    if (!ek) return;
    // "amount:asc" 형태로 파싱
    const [type, dir] = ek.split(':') as [OrderType, OrderDir];
    if (isActive(type, dir))
      orderChange(undefined); // 같은 걸 다시 누르면 해제
    else orderChange({ type, dir });
    // 언컨트롤드이므로 자동으로 닫힘
  };

  return (
    <DropdownButton
      id="order_by_btn"
      variant="default"
      className=""
      title={
        <div className={`${orderValue ? 'active' : ''}`}>
          <FaSortAmountDown />
          <span>정렬</span>
          {/* {!orderValue && <IoIosClose className="close_icon"/>} */}
        </div>
      }
      onSelect={handleSelect}
    >
      <Dropdown.Item
        eventKey="custom:asc"
        className={`order_by_item ${isActive('custom', 'asc') ? 'order_active' : ''}`}
      >
        <IoArrowBack className="arrow_icon reverse" />
        <span>단말기 순번 정렬</span>
      </Dropdown.Item>

      <Dropdown.Divider />

      <Dropdown.Item
        eventKey="amount:asc"
        className={`order_by_item ${isActive('amount', 'asc') ? 'order_active' : ''}`}
      >
        <IoArrowBack className="arrow_icon" />
        <span>매출순 오름차순</span>
      </Dropdown.Item>

      <Dropdown.Item
        eventKey="amount:desc"
        className={`order_by_item ${isActive('amount', 'desc') ? 'order_active' : ''}`}
      >
        <IoArrowBack className="arrow_icon reverse" />
        <span>매출순 내림차순</span>
      </Dropdown.Item>

      <Dropdown.Divider />

      <Dropdown.Item
        eventKey="alias:asc"
        className={`order_by_item ${isActive('alias', 'asc') ? 'order_active' : ''}`}
      >
        <IoArrowBack className="arrow_icon" />
        <span>이름순 오름차순</span>
      </Dropdown.Item>

      <Dropdown.Item
        eventKey="alias:desc"
        className={`order_by_item ${isActive('alias', 'desc') ? 'order_active' : ''}`}
      >
        <IoArrowBack className="arrow_icon reverse" />
        <span>이름순 내림차순</span>
      </Dropdown.Item>

      <Dropdown.Divider />

      <Dropdown.Item
        eventKey="cnt:asc"
        className={`order_by_item ${isActive('cnt', 'asc') ? 'order_active' : ''}`}
      >
        <IoArrowBack className="arrow_icon" />
        <span>개수별 오름차순</span>
      </Dropdown.Item>

      <Dropdown.Item
        eventKey="cnt:desc"
        className={`order_by_item ${isActive('cnt', 'desc') ? 'order_active' : ''}`}
      >
        <IoArrowBack className="arrow_icon reverse" />
        <span>개수별 내림차순</span>
      </Dropdown.Item>
    </DropdownButton>
  );
}
